export default __webpack_public_path__ + "static/media/problem_solving.177453a4.jpg";